import apis from "../../../api/apis";
import { APIResponseType } from "../../../config/enumApiResponseTypes";
import { IBaseModel } from "../../../interfaces/base";
import {
  IPartnerMenuItemListResponseModel,
  IPartnerMenuItemRequestModel,
  IPartnerMenuItemUpdateRequestModel,
} from "../../../interfaces/menu";
import {
  BULK_UPLOAD_ERROR,
  // BULK_UPLOAD_ERROR_PARTNER,
  BULK_UPLOAD_LOADING,
  //BULK_UPLOAD_LOADING_PARTNER,
  BULK_UPLOAD_SUCCESS,
  //BULK_UPLOAD_SUCCESS_PARTNER,
  GET_ALL_MENU_ERROR,
  GET_ALL_MENU_LOAD,
  GET_ALL_MENU_SUCCESS,
  UPDATE_ITEM_ERROR,
  UPDATE_ITEM_LOAD,
  UPDATE_ITEM_SUCCESS,
} from "../types";

export const getMenuList = (data: IBaseModel) => async (dispatch: any) => {
  try {
    dispatch({
      type: GET_ALL_MENU_LOAD,
    });

    const response = await apis.Menus.getMenuItemList(data);
    // console.log("response")
    //   console.log(response.ResponseData.MenuItemList)

    if (response.ResponseType === APIResponseType.Success) {
      dispatch({
        type: GET_ALL_MENU_SUCCESS,
        payload: response.ResponseData.MenuItemList,
      });
    } else {
      dispatch({
        type: GET_ALL_MENU_ERROR,
        payload: null,
      });
    }
  } catch (error) {
    dispatch({
      type: GET_ALL_MENU_ERROR,
      payload: error,
    });
  }
};

export const uploadBulkMenu =
  (data: IPartnerMenuItemRequestModel) => async (dispatch: any) => {
    try {
      dispatch({
        type: BULK_UPLOAD_LOADING,
      });

      //let successResponseCount = 0;
      //console.log(data)
      const res = await apis.Menus.uploadBulkMenuItemList(data);
      //  console.log("res")
      //  console.log(res)
      //console.log("res", res);
      if (res.ResponseType === APIResponseType.Success) {
        dispatch({
          type: BULK_UPLOAD_SUCCESS,
          payload: res,
        });
        /* successResponseCount++;
        console.log("success", successResponseCount);
        if (loopCount > 0 && loopCount === successResponseCount) {
          const res = await apis.Menus.uploadToPartnerSide(dataSignal);
          if (res.ResponseType === APIResponseType.Success) {
            dispatch({
              type: BULK_UPLOAD_SUCCESS,
              payload: res,
            });
            successResponseCount = 0;
          } else {
            dispatch({
              type: BULK_UPLOAD_ERROR,
              payload: res,
            });
            successResponseCount = 0;
          }
        } */
      } else if (res.ResponseType === APIResponseType.Error) {
        dispatch({
          type: BULK_UPLOAD_ERROR,
          payload: res,
        });
      } else {
        dispatch({
          type: BULK_UPLOAD_ERROR,
          payload: res,
        });
      }

      // if (res.ResponseType === APIResponseType.Success) {
      //      dispatch({
      //             type:BULK_UPLOAD_SUCCESS,
      //             payload:res
      //         })
      // }else{
      // dispatch({
      //             type:BULK_UPLOAD_ERROR,
      //             payload:res
      //         })
      // }
    } catch (error) {
      dispatch({
        type: BULK_UPLOAD_ERROR,
        payload: error,
      });
    }
  };

/* export const uploadBulkMenuToPartner =
  (data: IPartnerMenuItemRequestModel) => async (dispatch: any) => {
    try {
      dispatch({
        type: BULK_UPLOAD_LOADING_PARTNER,
      });
      //console.log(data)
      const res = await apis.Menus.uploadToPartnerSide(data);
      //  console.log("res")
      //  console.log(res)
      //  console.log("res")
      dispatch({
        type: BULK_UPLOAD_SUCCESS_PARTNER,
        payload: res,
      });

      // if (res.ResponseType === APIResponseType.Success) {
      //      dispatch({
      //             type:BULK_UPLOAD_SUCCESS,
      //             payload:res
      //         })
      // }else{
      // dispatch({
      //             type:BULK_UPLOAD_ERROR,
      //             payload:res
      //         })
      // }
    } catch (error) {
      dispatch({
        type: BULK_UPLOAD_ERROR_PARTNER,
        payload: error,
      });
    }
  }; */

export const updateMenu =
  (data: IPartnerMenuItemUpdateRequestModel) => async (dispatch: any) => {
    try {
      dispatch({
        type: UPDATE_ITEM_LOAD,
      });

      // console.log("data")
      // console.log(data)
      const response = await apis.Menus.updateItem(data);
      // console.log("response")
      // console.log(response)

      if (response.ResponseType === APIResponseType.Success) {
        dispatch({
          type: UPDATE_ITEM_SUCCESS,
          payload: response,
        });
      } else {
        dispatch({
          type: UPDATE_ITEM_ERROR,
          payload: response,
        });
      }
    } catch (error) {
      dispatch({
        type: UPDATE_ITEM_ERROR,
      });
    }
  };
